export default __webpack_public_path__ + "static/media/physical-tip.bf4e83af.svg";